import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '../../services/data/data.service';

declare var AwsWafCaptcha: any;
@Component({
    selector: 'nsc-dialog-captcha',
    templateUrl: './dialog-captcha.component.html',
    styleUrls: ['./dialog-captcha.component.scss'],
    standalone: false
})
export class DialogCaptchaComponent implements OnInit, AfterViewInit, OnDestroy {
  private wafCaptchaToken: string|null= null;
  private time:any;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; body?: string , id?:string},
    public dialogRef: MatDialogRef<DialogCaptchaComponent>,
    private dataService: DataService
  ) {}

  
  ngOnInit() {
  }
  
  get wafCaptchaTokenValue(): string|null {
    return this.wafCaptchaToken;
  }
  
  ngAfterViewInit() {
    const wafCaptchaApiKey = this.dataService.get().propertyConfig?.wafCaptchaAuthKey;
    const captchaWrapper = document.querySelector('#waf-captcha-wrapper');
    AwsWafCaptcha.renderCaptcha(captchaWrapper, {
      apiKey: wafCaptchaApiKey,
      dynamicWidth: true,
      onSuccess: (token: string) => {
        this.wafCaptchaToken = token;        
        this.time= setTimeout(() => {
          this.dialogRef.close(token)
        }, 2000);
      },
      onError: (err: any) => {
        console.error('captcha error', err);
      },
    });
  }
  
  ngOnDestroy() {
     clearTimeout(this.time);
  } 

  close(): void {
    this.dialogRef.close(this.wafCaptchaToken);
  }
  


}
